import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';

import DateHelper from '../../../../utilities/DateHelper';
import { useBuilder } from '../../useBuilder';
import { AssetWritingLogService } from '../../../../services/AssetWritingLogService';
import {AssetWritingLogs} from '../../../../entities/AssetWritingLogs';
import { EventTracking } from '../../../../utilities/Tracking/EventTracking';

interface Props {
    showDialog: boolean;
    closeDialog: () => void;
}

export function WritingLogDialog(props:Props) {
    const builder = useBuilder();

    const [writingLogs, setWritingLogs] = useState<AssetWritingLogs>({ writingLogs: [], id: '', totalTime: 0})
    const { showDialog, closeDialog } = props
    const [disabled, setDisabled] = useState<boolean>(false)
    
    useEffect(() => {
        setWritingLogs(builder.writingLogs);
    }, [builder])

    const handleRemoveWritingLog = async(id:string) => {
        setDisabled(true);
        await AssetWritingLogService.deleteAssetWritingLog(id);
        EventTracking.Builder.onDeleteWritingLogs("Analyzer Drawer Interaction")
        setDisabled(false)

        builder.refreshWritingLog();
        builder.setAlert("Writing log deleted")
    }

    return (
        <Dialog
        open={showDialog}
        onClose={closeDialog}
        >
            <DialogTitle>Writing Logs</DialogTitle>
            <DialogContent>
                {   writingLogs.totalTime > 0
                        &&
                    <List>
                        { writingLogs.writingLogs.map( (log, index) => {
                            return (
                            <ListItem key={index}>
                                <ListItemText>{DateHelper.buildDateFormat(new Date(log.logDate))} - {DateHelper.timeFromSeconds(log.logTimeInSeconds)}</ListItemText>
                                <ListItemSecondaryAction>
                                    <IconButton disabled={disabled} onClick={() => handleRemoveWritingLog(log.id,)} >
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                            )
                            })
                        }
                    </List>
                }
                <DialogActions>
                    <Button onClick={closeDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}